import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiShield } = FiIcons;

const DemoBanner = ({ className = "" }) => {
  return (
    <div className={`bg-blue-50 border border-blue-100 rounded-lg p-4 mb-6 ${className}`}>
      <div className="flex items-start space-x-3">
        <SafeIcon icon={FiShield} className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0" />
        <div>
          <p className="text-sm font-medium text-blue-800 mb-1">
            Privacy-first AI
          </p>
          <p className="text-sm text-blue-700 leading-relaxed">
            Werkt direct in je browser. Geen account. Geen data-opslag.
          </p>
        </div>
      </div>
    </div>
  );
};

export default DemoBanner;